import { SubheaderText as StyledSubheaderText } from './SubheaderText.styles';
import * as React from 'react';

export interface SubheaderTextProps {
  /**
   * Subheader text contents
   */
  label: string;
}

/**
 * The second most prominent text on the screen, used in the Report sidebar.
 */
export const SubheaderText: React.FC<SubheaderTextProps> = ({
  label,
}: SubheaderTextProps) => {
  return <StyledSubheaderText>{label}</StyledSubheaderText>;
};

export default SubheaderText;
